import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Account = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();

    if (!name || !email || !password) {
      toast.error("Please fill out all fields!");
      return;
    }

    sessionStorage.setItem("user", JSON.stringify({ name, email, password }));
    toast.success("Account created successfully 🎉");

    setTimeout(() => navigate("/"), 1000);
  };

  return (
    <section className="sx-auth">
      <div className="sx-auth-box">
        <h2>Create your account</h2>
        <p className="sx-auth-sub">
          Join Awaneez for faster checkout & order tracking
        </p>

        <form onSubmit={handleRegister}>
          {/* NAME */}
          <div className="sx-field">
            <label>Full Name</label>
            <input
              type="text"
              placeholder="John Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          {/* EMAIL */}
          <div className="sx-field">
            <label>Email Address</label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* PASSWORD */}
          <div className="sx-field sx-password">
            <label>Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Minimum 6 characters"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span onClick={() => setShowPassword(!showPassword)}>
              <i className={`ph ${showPassword ? "ph-eye" : "ph-eye-slash"}`} />
            </span>
          </div>

          <button type="submit" className="sx-btn-primary">
            Create Account
          </button>
        </form>

        {/* Divider */}
        <div className="sx-divider">Already have an account?</div>

        {/* Login */}
        <p className="sx-auth-footer">
          <Link to="/login">Sign in instead</Link>
        </p>

        {/* Terms */}
        <p className="sx-terms">
          By continuing, you agree to our{" "}
          <Link to="/privacy-policy">Privacy Policy</Link> &{" "}
          <Link to="/terms-and-conditions">Terms of Use</Link>.
        </p>
      </div>

      {/* CSS */}
      <style>{`
        .sx-auth {
          min-height: 90vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f4f6fb;
          padding: 30px 16px;
        }

        .sx-auth-box {
          width: 100%;
          max-width: 460px;
          background: #ffffff;
          padding: 40px;
          border: 1px solid #e5e7eb;
        }

        .sx-auth-logo {
          text-align: center;
          margin-bottom: 18px;
        }

        .sx-auth-logo img {
          width: 150px;
        }

        .sx-auth-box h2 {
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          color: #111;
          margin-bottom: 6px;
        }

        .sx-auth-sub {
          text-align: center;
          font-size: 14px;
          color: #666;
          margin-bottom: 28px;
        }

        .sx-field {
          margin-bottom: 18px;
        }

        .sx-field label {
          display: block;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 6px;
          color: #333;
        }

        .sx-field input {
          width: 100%;
          height: 46px;
          padding: 0 14px;
          border: 1px solid #d1d5db;
          font-size: 14px;
          outline: none;
        }

        .sx-field input:focus {
          border-color: #2563eb;
        }

        .sx-password {
          position: relative;
        }

        .sx-password span {
          position: absolute;
          right: 14px;
          top: 38px;
          cursor: pointer;
          font-size: 18px;
          color: #555;
        }

        .sx-btn-primary {
          width: 100%;
          height: 48px;
          background: #111;
          color: #fff;
          border: none;
          font-weight: 600;
          cursor: pointer;
          margin-top: 6px;
          transition: .3s;
        }

        .sx-btn-primary:hover {
          background: #2563eb;
        }

        .sx-divider {
          text-align: center;
          margin: 22px 0 10px;
          font-size: 13px;
          color: #888;
        }

        .sx-auth-footer {
          text-align: center;
          font-size: 14px;
        }

        .sx-auth-footer a {
          color: #2563eb;
          font-weight: 600;
          text-decoration: none;
        }

        .sx-terms {
          margin-top: 14px;
          text-align: center;
          font-size: 12px;
          color: #777;
        }

        .sx-terms a {
          color: #2563eb;
          text-decoration: none;
        }
      `}</style>
    </section>
  );
};

export default Account;
